<template>
<div style="position:relative;width:100%;height:100%">
  <el-button v-if="showBackBtn || showReturnBtn" size="mini" style="position:absolute;top:0;left:0;z-index:1;" class="back-btn" @click="onBackBtnClick">返回</el-button>
  <div ref="chart" class="chart"></div>
</div>
</template>

<script>
import * as echarts from 'echarts'

import * as EventKeyMap from './EventKeys'

export default {
  name: 'EChart',
  props: {
    showBackBtn: Boolean
  },
  computed: {
    showReturnBtn () {
      return false
    }
  },
  methods: {
    afterInit (chart) {
      this.$emit('initialized', chart)
    },
    destroy () {
      this.$emit('destroy', this.myChart)
    },
    getChartWrapper () {
      return this.$refs.chart
    },
    clear () {
      let myChart = this.myChart
      myChart && myChart.clear()
    },
    setOpt (option, isReal) {
      let myChart = this.myChart

      if (!myChart) {
        return
      }

      if (!isReal) {
        this.clear()
      }

      myChart.setOption(option)
    },
    getOpt () {
      let {myChart} = this
      return myChart && myChart.getOption()
    },
    refreshOpt (opt, updateOpt) {
      let {myChart} = this

      if (!myChart) {
        return
      }

      myChart.setOption(opt, updateOpt)
    },
    getLinear (x1, y1, x2, y2, opts) {
      return new echarts.graphic.LinearGradient(x1, y1, x2, y2, opts)
    },
    getData (list, callback) {
      return echarts.util.map(list, callback)
    },
    connect (chartComponentList) {
      echarts.connect(chartComponentList.map(chartComponent => chartComponent.myChart))
    },
    resize () {
      this.myChart && document.body.contains(this.$el) && this.myChart.resize()
    },
    onWindowResize () {
      this.resize()
    },
    onBackBtnClick () {
      this.$emit('back')
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.afterInit(this.myChart = echarts.init(this.getChartWrapper()))
      this.$eventBus.on(EventKeyMap.WINDOW_RESIZE, this.onWindowResize)
    })
  },
  beforeDestroy () {
    let myChart = this.myChart

    if (myChart) {
      this.destroy()
      this.clear()
      myChart.dispose()
      this.myChart = null
    }

    this.$eventBus.off(EventKeyMap.WINDOW_RESIZE, this.onWindowResize)
  }
}
</script>

<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/ECharts.vue